import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { XCircle, ArrowLeft, RefreshCw } from "lucide-react";

export default function BookingCancel() {
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get("booking_id");

  return (
    <div className="min-h-screen bg-background flex items-center justify-center py-12 px-4" data-testid="booking-cancel-page">
      <Card className="max-w-md w-full shadow-2xl border-0 rounded-3xl overflow-hidden">
        <div className="bg-destructive p-8 text-center">
          <XCircle className="w-20 h-20 text-white mx-auto mb-4" />
          <h1 className="text-3xl font-extrabold text-white mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Payment Cancelled
          </h1>
          <p className="text-white/90">
            Your payment was not completed
          </p>
        </div>

        <CardContent className="p-8">
          <p className="text-center text-muted-foreground mb-8">
            Don't worry! Your booking has been saved. You can complete the payment anytime or choose a different payment method.
          </p>

          <div className="flex flex-col gap-4">
            {bookingId && (
              <Link to={`/book`}>
                <Button className="w-full rounded-full h-12 bg-primary text-primary-foreground">
                  <RefreshCw className="w-4 h-4 mr-2" />
                  Try Again
                </Button>
              </Link>
            )}
            <Link to="/">
              <Button variant="outline" className="w-full rounded-full h-12">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Home
              </Button>
            </Link>
          </div>

          <p className="text-center text-sm text-muted-foreground mt-6">
            Need help? Contact us via WhatsApp or email.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
